import { useTranslation } from 'react-i18next';

import { Button } from '@codes/ui-kit/components/ui/button';
import { KeyIcon, PlusIcon } from 'lucide-react';

interface AccessKeyEmptyStateProps {
    onCreateClick: () => void;
}

export const AccessKeyEmptyState = ({ onCreateClick }: AccessKeyEmptyStateProps) => {
    const { t } = useTranslation();

    return (
        <div className="flex flex-col items-center justify-center py-16 text-center">
            <div className="mb-4 rounded-full bg-muted p-6">
                <KeyIcon className="h-12 w-12 text-muted-foreground" />
            </div>
            <h3 className="mb-2 text-lg font-semibold">{t('accessKeys.emptyState.title')}</h3>
            <p className="mb-6 max-w-sm text-sm text-muted-foreground">{t('accessKeys.emptyState.description')}</p>
            <Button onClick={onCreateClick}>
                <PlusIcon className="mr-2 h-4 w-4" />
                {t('accessKeys.emptyState.cta')}
            </Button>
        </div>
    );
};
